<template>
  <div>
    <p class="mb-2 text-base md:mb-3">
      {{ $t("sidebar.enterVINCode") }}
    </p>

    <p class="block mb-1 font-bold">Vehicle Identification Number</p>
    <div class="flex flex-wrap items-center w-full gap-x-3 gap-y-1">
      <div class="w-40">
        <validation-provider name="VIN" mode="eager" rules="required" v-slot="{ errors }">
          <input
            class="block w-full form-input"
            placeholder="VIN"
            v-model="vinNumber"
            type="text"
          />
          <span class="absolute block px-1 mt-1 text-xs text-red-100 bg-red-500 rounded-sm shadow-lg">{{ errors[0] }}</span>
        </validation-provider>
      </div>
      <base-button
        class="w-auto"
        :loading="isLoading"
        :disabled="!vinNumber"
        @click="handleSubmit(vinNumber)"
      >
        {{ $t("sidebar.search") }}
      </base-button>
    </div>
    <transition name="fade">
      <div
        v-if="notFound"
        class="px-3 py-3 mt-4 text-teal-900 bg-gray-200 border-t-4 rounded-sm border-lightblue"
        role="alert"
      >
        <div class="flex">
          <div class="py-1">
            <svg
              class="w-5 h-5 mr-3 fill-current text-lightblue"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
              />
            </svg>
          </div>
          <div>
            <p class="font-bold"> {{ $t("sidebar.notFound") }}</p>
          </div>
        </div>
      </div>
    </transition>
    <base-select
      v-if="Array.isArray(this.vin.types) && vin.types.length > 1 && vin && !notFound"
      :placeholder="$t('sidebar.type')"
      :label="$t('sidebar.type')"
      :options="vin.types"
      @selected="setData"
      target="vin"
    ></base-select>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { mapActions, mapState, mapMutations } from 'vuex';
import { updateUrlParams } from '@/util/url-params';

extend('required', required);

export default {
  data: () => ({
    vinNumber: process.env.NODE_ENV === 'development' ? '4Y1SL65848Z411439' : '',
    isLoading: false
  }),
  components: {
    BaseSelect,
    BaseButton,
    ValidationProvider
  },
  computed: {
    ...mapState({
      vin: state => state.apiData.vin,
      notFound: state => state.apiData.vin.notFound
    })
  },
  methods: {
    ...mapActions(['GET_TYPES_BY_VIN', 'GET_RESULTS', 'UNSET_SELECTED']),
    ...mapMutations(['SET_TYPES_BY_VIN', 'SET_SELECTED']),
    async setData (prop) {
      await this.UNSET_SELECTED({
        selected: ['vehicle', 'make', 'model', 'type'],
        data: ['makers', 'models', 'types', 'results']
      });
      await this.GET_RESULTS(prop.value);
    },
    async handleSubmit (vin) {
      this.isLoading = true;
      this.SET_TYPES_BY_VIN([]);
      await this.UNSET_SELECTED({
        selected: ['vehicle', 'make', 'model', 'type'],
        data: ['makers', 'models', 'types', 'results']
      });
      try {
        await this.GET_TYPES_BY_VIN({ vin: vin });
        if (!this.notFound) {
          if (!Array.isArray(this.vin.types)) {
            updateUrlParams('selectedType', this.vin.types);
          } else {
            updateUrlParams('selectedType', this.vin.types[0].value);
          }
        }
      } catch (err) {
        console.error(err);
      }
      this.isLoading = false;
    }
  }
};
</script>

<style lang="postcss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}
.fade-enter, .fade-leave-to  {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
